module.exports = __webpack_public_path__ + "static/media/domain-black-18dp.a9975c23.svg";